import { render, staticRenderFns } from "./points-reward-card.vue?vue&type=template&id=261b033e"
import script from "./points-reward-card.vue?vue&type=script&lang=js"
export * from "./points-reward-card.vue?vue&type=script&lang=js"
import style0 from "./points-reward-card.vue?vue&type=style&index=0&id=261b033e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports